var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MonacoEditor',{staticStyle:{"width":"100%","min-height":"300px"},attrs:{"value":_vm.computedValue,"language":_vm.language,"theme":"vs-dark","options":_vm.editorOptions},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }